import React from 'react';
import { compose, withProps } from 'recompose';
import { getAvatarInitials } from '../../../helpers/pension-finder';
import styles from '../../../styles/widgets/pension-finder/pension-finder-avatar.module.scss';

const logoStyle = index => ({
  '--job-card-logo-background-color': `var(--job-card-logo-${index + 1}-background-colour)`,
  '--job-card-logo-text-color': `var(--job-card-logo-${index + 1}-text-colour)`
});

const AvatarComponent = React.memo(({ companyLogo, style }) => (
  <div className={styles.container} style={style}>
    <h2 className={styles.text}>{companyLogo}</h2>
  </div>
));

export const CompanyAvatar = compose(
  withProps(({ index, title }) => ({
    companyLogo: getAvatarInitials(title),
    style: logoStyle(index)
  }))
)(AvatarComponent);
